import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import { CLS_PREFIX } from '../../constants';
var OFFSET = 23;

var calculate = function calculate(rect, placement) {
  var placementTop = rect.height / 2;
  var placementLeft = 0;

  switch (placement) {
    case 'left':
      placementLeft = Math.min(OFFSET, rect.height / 2);
      break;

    case 'right':
      placementLeft = rect.width - Math.min(OFFSET, rect.height / 2);
      break;

    case 'center':
      placementLeft = rect.width / 2;
      break;
  }

  var top = rect.top + placementTop - OFFSET + window.pageYOffset;
  var left = rect.left + placementLeft - OFFSET + window.pageXOffset;
  return {
    top: top,
    left: left
  };
};

var SpotPulsar = forwardRef(function SpotPulsar(_ref, ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "spot-pulsar") : _ref$baseClassName,
      className = _ref.className,
      rect = _ref.rect,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'center' : _ref$placement,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "rect", "placement"]);

  var position = calculate(rect, placement);
  return React.createElement("div", _extends({
    className: classNames(baseClassName, className),
    style: {
      transform: "translate(".concat(position.left, "px, ").concat(position.top, "px)")
    }
  }, props, {
    ref: ref
  }), React.createElement("div", {
    className: "".concat(baseClassName, "__ring")
  }), React.createElement("div", {
    className: "".concat(baseClassName, "__ring")
  }));
});
SpotPulsar.displayName = 'SpotPulsar';
export default SpotPulsar;